var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRequestAccepted = function SvgRequestAccepted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 12.6667L13.8 14.2222L17 11.1111M9 10.3333H5.8C4.30899 10.3333 3.56348 10.3333 2.97541 10.5702C2.19132 10.8859 1.56837 11.4916 1.24359 12.2539C1 12.8256 1 13.5504 1 15M11.8 1.22615C12.9727 1.68767 13.8 2.80546 13.8 4.11111C13.8 5.41676 12.9727 6.53455 11.8 6.99608M10.2 4.11111C10.2 5.82933 8.76731 7.22222 7 7.22222C5.23269 7.22222 3.8 5.82933 3.8 4.11111C3.8 2.39289 5.23269 1 7 1C8.76731 1 10.2 2.39289 10.2 4.11111Z",
    stroke: "#535353",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequestAccepted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/requestAccepted.6b3938ec.svg";
export { ForwardRef as ReactComponent };